import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReviewCaseClosingSummaryComponent } from '../../../../components/review-content/review-case-closing-summary/review-case-closing-summary.component';

@Component({
  selector: 'case-closing-submission',
  standalone: true,
  imports: [
    CommonModule,
    ReviewCaseClosingSummaryComponent
  ],
  templateUrl: './case-closing-submission.component.html',
  styleUrl: './case-closing-submission.component.css'
})
export class CaseClosingSubmissionComponent implements OnInit {

  @Input() caseClosingSummaryData: any;
  @Output() onSaveSection4 = new EventEmitter<any>();

  currentCaseId: string | null = null;

  ngOnInit(): void {
    if (this.caseClosingSummaryData) {
      this.currentCaseId = this.caseClosingSummaryData.case_id;
    }
  }

  submitCaseClosingSummary(): void {
    this.onSaveSection4.emit({});
  }

}
